export default {
  FORM_NAME: 'modifyTerms',
  SHIPMENT_PAYMENT_SELLER: '1',
  INITIALISE_VALUES: 'INITIALISE_VALUES',
  INITIALISE_FAILED: 'INITIALISE_FAILED',
};
